import React, { useEffect, useState } from 'react';
import classes from './Card.module.css';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

const Card = ({ backgroungImage, iconImg, color, iconMargin, children }) => {
    const direction = useSelector(state => state.translate.direction);
    const [image, setImage] = useState();
    const [icon, setIcon] = useState();

    useEffect(() => {
        if (backgroungImage) {
            const img = require(`../../assests/${backgroungImage}`);
            setImage(img.default);
        }   
    }, [backgroungImage])

    useEffect(() => {
        if (iconImg) {
            const img = require(`../../assests/${iconImg}`);
            setIcon(img.default);
        }
    }, [iconImg])

    return (<div className={`${classes.Card} ${classes[direction]}`} style={{ backgroundImage: image && `url(${image})`, background: color }}>
        <img className={classes.icon} style={{ marginInlineStart: iconMargin }} src={icon} />
        {children}
    </div>)
}

Card.propTypes = {
    backgroungImage: PropTypes.string
}

export default Card;